import { render, staticRenderFns } from "./list-price-grid.vue?vue&type=template&id=63fc132b&scoped=true"
import script from "./list-price-grid.vue?vue&type=script&lang=js"
export * from "./list-price-grid.vue?vue&type=script&lang=js"
import style0 from "./list-price-grid.vue?vue&type=style&index=0&id=63fc132b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc132b",
  null
  
)

export default component.exports